import { DividerComponent } from 'content/models/LessonComponent';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import { StyleFormatter } from '../../services/StyleService';

interface DividerComponentProps {
  component: DividerComponent;
}

export default function DividerComponentView(props: DividerComponentProps) {
  return (
    <Grid>
      <hr
        style={{
          flex: 1,
          ...StyleFormatter({ ...props.component.settings.dividerStyles })
        }}
      />
    </Grid>
  );
}
